import { map, omit } from 'lodash';

const KEYS_TO_OMIT = ['computedBill', 'computedBillRules', 'optimizations', 'validations'];

export const getAllDataFromSnapshotWithBoundId = (snapshot) =>
  map(snapshot.docs, (doc) => ({ ...omit(doc.data(), KEYS_TO_OMIT), id: doc.id }));
